export default "__VITE_ASSET__DasCscUA__"